<template>

    <v-action :name="name">
        <v-input-numeric :model="model" :min="min" :max="max" @input="onInput" />
    </v-action>

</template>

<script>

import Action from './Action';

export default {

    components: {
        'v-action': Action,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 1000,
        },
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        model() {
            return parseInt(this.block.items[0][this.key[0]].replace(/\D/g, '') || 0);
        },

        name() {
            let name = '';
            if (this.type === 'border-radius') {
                name = 'Radius';
            } else if (this.type === 'size') {
                name = 'Size';
            }
            return name;
        },

        key() {
            let key = [];
            if (this.type === 'border-radius') {
                key = ['border_radius'];
            } else if (this.type === 'size') {
                key = ['height', 'width'];
            }
            return key;
        },

    },

    methods: {

        onInput(val) {
            let block = this.block;
            block.items.forEach(item => {
                this.key.forEach(key => {
                    item[key] = val + 'px';
                });
            });
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>